
































































import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import i18n from '@/plugins/i18n';
import Mixin from '@/mixins/base';

enum DialogTypes {
  EDIT = 'edit',
  ADD = 'add',
}

@Component({
  mixins: [Mixin]
})
export default class EditDialogWrapper extends Mixins(Mixin) {
  private dialogShown = false;

  @Prop({ type: Boolean, default: true })
  private readonly scrollable!: boolean;

  @Prop({ type: Boolean, default: true })
  private readonly visible!: boolean;

  @Prop({ type: Boolean, default: true })
  private readonly allowedToSave!: boolean;

  @Prop({ type: Boolean, default: true })
  private readonly destructiveAction!: boolean;

  @Prop({ type: Number, default: 550 })
  private readonly maxWidth!: number;

  @Prop({
    default: DialogTypes.EDIT,
    validator: (val) => Object.values(DialogTypes).includes(val)
  })
  private readonly type!: DialogTypes;

  @Prop({ type: String })
  private readonly tooltipText!: string | undefined;

  @Prop({ type: String })
  private readonly icon!: string | undefined;

  @Prop({ required: true, type: Function })
  private readonly saveAction!: () => Promise<void>;

  private get isEditDialog(): boolean {
    return this.type === DialogTypes.EDIT;
  }

  private get isAddDialog(): boolean {
    return this.type === DialogTypes.ADD;
  }

  private get dialogIcon(): string {
    if (this.icon) {
      return this.icon;
    }

    if (this.isEditDialog) {
      return 'mdi-pencil';
    }

    if (this.isAddDialog) {
      return 'mdi-plus-circle';
    }

    return '';
  }

  private get tooltip(): string | undefined {
    if (!this.tooltipText) {
      if (this.isAddDialog) {
        return i18n.t('common.dialog.action.add').toString();
      }

      if (this.isEditDialog) {
        return i18n.t('common.dialog.action.edit').toString();
      }
    }

    return this.tooltipText;
  }

  private async doAction(): Promise<boolean> {
    const confirmed: boolean = this.destructiveAction
      ? (await this.$confirm(this.$t('common.dialog.confirmation.save').toString()) || false)
      : true;

    if (confirmed) {
      try {
        await this.saveAction();
        this.dialogShown = false;
      } catch {
        // Do nothing
      }

      return true;
    }

    return false;
  }

  @Watch('dialogShown')
  public async visibilityChangedHandler(currentState: boolean, previousState: boolean): Promise<void> {
    if (currentState && !previousState) {
      this.$emit('open');
    } else {
      this.$emit('close');
    }
  }
}
